import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Tasks.SELECT_CAMPAIGN_TO_REMOVE_CONTACT_FROM:
      return action.payload
    case ActionType.Tasks.RECEIVE_TASK:
      if (
        typeof action.payload?.remove_from_campaign?.trigger_data
          ?.campaign_id !== 'undefined'
      ) {
        return (
          action.payload?.remove_from_campaign?.trigger_data?.campaign_id ||
          null
        )
      }

      return null
    default:
      return state
  }
}
